export default __webpack_public_path__ + "static/media/codechef.1c235071.png";